import React, { Component } from 'react';

import './DeferredLanding.css'

import MainTop from './Header';
import { Link } from 'react-router-dom';

class DeferredLanding extends Component {

  componentDidMount() {
    const query = this.getQuery();
    const os = this.detectOS();

    if (!query.type || !query.id) {
      console.warn("Invalid deep link params");
      return;
    }

    this.trackClick(query)
      .then(({ token }) => {
        if (!token) return;

        // Android
        if (os.isAndroid) {
          window.location.href = this.buildAndroidIntent(token);
          return;
        }

        // iOS
        if (os.isIOS) {
          const appLink = this.buildIOSUniversalLink(token);
          window.location.href = appLink;

          // Universal Link 실패 시 App Store
          this.iosFallbackTimer = setTimeout(() => {
            window.location.href = this.APP_STORE;
          }, 1500);
          return;
        }

        // PC / 기타
        window.location.href = `/web/${query.type}/${query.id}`;
      })
      .catch(err => {
        console.error("DeferredLanding error", err);
      });
  }

  componentWillUnmount() {
    if (this.iosFallbackTimer) {
      clearTimeout(this.iosFallbackTimer);
    }
  }

  /* ========================
     Utils
     ======================== */

  getQuery() {
    const hash = window.location.hash; 
    // "#/link?type=post&id=123"

    const queryIndex = hash.indexOf("?");
    if (queryIndex === -1) {
      return { type: null, id: null };
    }

    const queryString = hash.substring(queryIndex + 1);
    const params = new URLSearchParams(queryString);

    return {
      type: params.get("type"),
      id: params.get("id"),
    };
  }

  detectOS() {
    const ua = navigator.userAgent.toLowerCase();

    return {
      isAndroid: ua.includes("android"),
      isIOS: /iphone|ipad|ipod/.test(ua),
      isMobile: /android|iphone|ipad|ipod/.test(ua),
    };
  }

  /* ========================
     Server
     ======================== */

  async trackClick(payload) {
    const res = await fetch("/rest/v1.0/link/gen/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(payload),
    });

    return res.json(); // { token: "abc123" }
  }

  /* ========================
     Deep Link Builders
     ======================== */

  buildAndroidIntent(token) {
    return (
      "intent://deferred/" + token +
      "#Intent;" +
      "scheme=myapp;" +
      "package=com.lemoncake.mlibrary;" +
      "S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.lemoncake.mlibrary;" +
      "end"
    );
  }

  buildIOSUniversalLink(token) {
    return `https://lemoncake-corp.com/d/${token}`;
  }

  /* ========================
     Constants
     ======================== */

  PLAY_STORE =
    "https://play.google.com/store/apps/details?id=com.lemoncake.mlibrary";

  APP_STORE =
    "https://apps.apple.com/app/id6745247420";

  /* ========================
     Render
     ======================== */

  render() {
    return (
      <div className="DeferredLanding">
          <header>
            <a href="/" className="title"><h1>MIDNIGHT LIBRARY</h1></a>
            앱으로 이동중입니다. 잠시만 기다려 주세요.
          </header>
          <MainTop/>
          <footer>
            <div>
              <span className="ci">LEMONCAKE</span>
              <div className="ci" style={{width:"40px"}}/>
              <span className="copyrights">Copyright ©2020 LEMONCAKE All Rights Reserved.</span>
              <div style={{width:"40px"}}>
                <hr style={{border: "solid 1px #222222", height:"10px"}}/>
              </div>
              <Link to="/privacy" className="privacy">개인정보처리방침</Link>
            </div>
          </footer>
      </div>
    );
  }
}

export default DeferredLanding;